// extracted by mini-css-extract-plugin
export var active = "_cr-c";
export var compactArrow = "_cr-5";
export var container = "_cr-0";
export var dot = "_cr-b";
export var dotContainer = "_cr-a";
export var hoverArrowButton = "_cr-7";
export var hoverArrowContainer = "_cr-6";
export var leftHoverArrowContainer = "_cr-8 _cr-6";
export var rightHoverArrowContainer = "_cr-9 _cr-6";
export var slide = "_cr-4";
export var sliderContainer = "_cr-1";
export var sliderContainerVisibleOverflow = "_cr-2";
export var sliderOverflow = "_cr-3";
export var vignetteBoth = "_cr-f";
export var vignetteLeft = "_cr-e";
export var vignetteRight = "_cr-d";